<template>
  <button :type :disabled="isLoading || disabled">
    <Transition>
      <AppLoader v-if="isLoading" />
    </Transition>
    <slot> Сохранить изменения </slot>
  </button>
</template>

<script lang="ts" src="./SubmitBtn.ts">

</script>

<style scoped lang="scss" src="./SubmitBtn.scss"></style>
